// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IdnWduPssEZnDrVmnDCX{border-top:1px solid var(--border-neutral-default);padding:4px}.nC29d_nv8acxM7gkPZIo{color:var(--gray-60);justify-content:center;padding:12px 0;font-size:12px;font-weight:400;display:flex}.pj9BNLxtjsjlHHXCfcim{color:var(--content-primary-primary);white-space:nowrap;text-overflow:ellipsis;font-size:13px;font-weight:400;line-height:16px;overflow:hidden}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropdownFooter": `IdnWduPssEZnDrVmnDCX`,
	"noResults": `nC29d_nv8acxM7gkPZIo`,
	"addButton": `pj9BNLxtjsjlHHXCfcim`
};
export default ___CSS_LOADER_EXPORT___;
